import React, {ComponentProps, memo} from 'react';
import Stack from '@mui/material/Stack';
import Loader from '../Loader/Loader';

const LoadingState = memo(function LoadingState(props: ComponentProps<typeof Stack>) {
    return (
        <Stack alignItems="center" justifyContent="center" height="100%" {...props}>
            <Loader />
        </Stack>
    );
});

export {LoadingState};
